import React, { useEffect } from 'react';
import { loginWithFacebook } from '../services/facebook-authentication.service';
import Button from './UI/button';

export interface FacebookLoginProps {
  isSignUp: boolean;
  loginSuccess: (success: boolean) => void;
}

const LoginWithFacebook: React.FC<FacebookLoginProps> = ({
  isSignUp,
  loginSuccess
}) => {
  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    await facebookRedirect();
  };

  const facebookRedirect = () => {
    const appId = '1827644754726407'; // Replace with your Facebook App ID
    const redirectUri = window.location.origin; // Use the current origin as the redirect URI
    const authUrl = `https://www.facebook.com/v12.0/dialog/oauth?client_id=${appId}&redirect_uri=${redirectUri}&scope=public_profile,email&response_type=token`;
    console.log('redirect', redirectUri);
    window.location.href = authUrl;
  };

  const facebookLogin = async (token: string) => {
    const success = await loginWithFacebook(token);
    loginSuccess(success ?? false);
  };

  useEffect(() => {
    // Initialize the Facebook SDK
    window.fbAsyncInit = function () {
      FB.init({
        appId: 'your-facebook-app-id', // Replace with your Facebook App ID
        cookie: true,
        xfbml: true,
        version: 'v12.0'
      });

      FB.AppEvents.logPageView();
    };

    // Load the SDK asynchronously
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      (js as HTMLScriptElement).src =
        'https://connect.facebook.net/en_US/sdk.js';
      if (fjs && fjs.parentNode) {
        fjs.parentNode.insertBefore(js, fjs);
      }
    })(document, 'script', 'facebook-jssdk');
  }, []);

  return (
    <Button
      onClick={handleClick}
      fontFamily='rubik'
      variant='dark'
      className='d-flex align-items-center justify-content-center px-1 g-col-6'
      style={{ gap: '8px' }}
    >
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_252_671)'>
          <path
            d='M20 10C20 4.4772 15.5228 0 10 0C4.4772 0 0 4.4772 0 10C0 14.6896 3.2288 18.6248 7.5844 19.7056V13.056H5.5224V10H7.5844V8.6832C7.5844 5.2796 9.1248 3.702 12.4664 3.702C13.1 3.702 14.1932 3.8264 14.6404 3.9504V6.7204C14.4044 6.6956 13.9944 6.6832 13.4852 6.6832C11.8456 6.6832 11.212 7.3044 11.212 8.9192V10H14.4784L13.9172 13.056H11.212V19.9268C16.1636 19.3288 20.0004 15.1128 20.0004 10H20Z'
            fill='white'
          />
          <path
            d='M13.9168 13.056L14.478 10H11.2116V8.91923C11.2116 7.30443 11.8452 6.68323 13.4848 6.68323C13.994 6.68323 14.404 6.69563 14.64 6.72043V3.95043C14.1928 3.82603 13.0996 3.70203 12.466 3.70203C9.12437 3.70203 7.58397 5.27963 7.58397 8.68323V10H5.52197V13.056H7.58397V19.7056C8.35757 19.8976 9.16677 20 9.99957 20C10.4096 20 10.814 19.9748 11.2112 19.9268V13.056H13.9168Z'
            fill='#2D2D2D'
          />
        </g>
        <defs>
          <clipPath id='clip0_252_671'>
            <rect
              width='20'
              height='20'
              fill='white'
            />
          </clipPath>
        </defs>
      </svg>
      Log in with Facebook
    </Button>
  );
};

export default LoginWithFacebook;
